import { EventBus } from '../../submodules/src/script/common';
import cr$ from '../../submodules/src/script/crquery';
import { CLOSE_DESKTOP_MENU_EVENT, SHOW_MOBILE_MENU_EVENT } from './events';
import throttle from 'lodash/throttle';


cr$.ready(function () {
    requestIdleCallback(() => {
        initHeader();
    });
});

const initHeader = () => {
    const desktopHeaderEl = cr$.byId('header-desktop');
    if (desktopHeaderEl.exists()) {
        window.addEventListener(
            'scroll',
            throttle(
                () => {
                    EventBus.$emit(CLOSE_DESKTOP_MENU_EVENT);
                },
                500,
                {
                    leading: true,
                    trailing: true,
                }
            ),
            { passive: true }
        );
    }

    const headerDrawerEl = cr$.byId('header-drawer-icon');
    if (headerDrawerEl.exists()) {
        // open drawer on icon click
        headerDrawerEl.click(() => EventBus.$emit(SHOW_MOBILE_MENU_EVENT));
    }
};

export const hideMobileHeader = () => {
    if (window.innerWidth < 768) {
        const scroll = document.body.scrollTop || document.documentElement.scrollTop;
        const mobileTopbarWrapperEl = cr$.byId('header-mobile-topbar-wrapper');

        if (mobileTopbarWrapperEl.exists() && scroll > mobileTopbarWrapperEl.raw.offsetHeight) {
            mobileTopbarWrapperEl.css('transform', 'translateY(-100%)');
            mobileTopbarWrapperEl.removeClass('shadow');
        }
    }
};
